<form class="notification-dialog"
      [formGroup]="formNotification">

  <owl-carousel-o [options]="customOptions">
    <ng-container *ngFor="let item of notifications">
      <ng-template carouselSlide
                   [id]="item.notificacaoId">
        <section fxLayout="row layout-wrap"
                 fxFlex="100%"
                 class="pos-relative">
          <div mat-dialog-title
               fxFlex="100%"
               fxLayout="row"
               fxLayoutAlign="center center">
            <h1>{{item.notificacao.titulo}}</h1>
            <div class="notification-dialog__button"
                 fxLayout="row">
              <button mat-flat-button
                      color="primary"
                      [matTooltip]="'Acessar link'"
                      matTooltipPosition="above"
                      *ngIf="item.notificacao.tipoConteudo == 'BANNER' && item.notificacao.linkRedirecionamento"
                      (click)="openNewUrl(item.notificacao.linkRedirecionamento)"
                      class="mr-2">
                <mat-icon>open_in_new</mat-icon>
              </button>
              <button color="primary"
                      mat-dialog-close
                      mat-mini-fab>
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>

          <mat-dialog-content fxLayout="row layout-wrap"
                              fxLayoutAlign="center center"
                              fxFlex="100%">

            <div *ngIf="item.notificacao.tipoConteudo == 'BANNER'"
                 class="notification-dialog__banner">
              <img [src]="item.notificacao.linkConteudo"
                   width="100%"
                   height="100%"
                   alt="">
            </div>

            <div class="notification-dialog__video"
                 *ngIf="item.notificacao.tipoConteudo == 'VIDEO'">
              <iframe [src]="item?.notificacao?.linkConteudo"
                      title="YouTube video player"
                      frameborder="0"
                      width="650"
                      height="350"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen>
              </iframe>
            </div>

            <div *ngIf="item.notificacao.tipoConteudo != 'VIDEO' && item.notificacao.tipoConteudo != 'BANNER'"
                 class="notification-dialog__content"
                 fxLayout="column"
                 fxLayoutAlign="center center">
              <span class="notification-dialog__span-icon"
                    [ngSwitch]="item.notificacao.tipo">
                <mat-icon class="notification-dialog__icon"
                          *ngSwitchCase="'AGENDAMENTO'">calendar_today</mat-icon>
                <mat-icon class="notification-dialog__icon"
                          *ngSwitchCase="'FINANCEIRO'">attach_money</mat-icon>
                <mat-icon class="notification-dialog__icon"
                          *ngSwitchCase="'GENERICO'">alarm</mat-icon>
                <mat-icon class="notification-dialog__icon"
                          *ngSwitchDefault>notifications_active</mat-icon>
              </span>
              <span class="notification-dialog__description">{{item.notificacao.textoPrincipal}}</span>
            </div>

          </mat-dialog-content>

          <mat-dialog-actions class="notification-dialog__actions w-100"
                              fxLayout="row"
                              fxLayoutAlign="center">

            <mat-checkbox formControlName="{{'notification_' + item.id}}"
                          (click)="onRead(item)"
                          color="primary">Li e Entendi</mat-checkbox>
          </mat-dialog-actions>
        </section>
      </ng-template>
    </ng-container>

  </owl-carousel-o>
</form>
